import { Box, Button, TextField } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import { User, UserNotifications } from '../../types/user';
import "./index.css"

interface Props {
    id: string;
    notifications: UserNotifications | undefined;
    user: User | undefined
    isShow: boolean
}

const checkPassword = (password: string, confirmPassword: string,): boolean => {
    if (password !== confirmPassword) {
        return false
    }
    return true
}

const SecurityTab: FC<Props> = ({ id, notifications, user, isShow }) => {
    const dataProvider = useDataProvider()
    const notify = useNotify()
    const [state, setState] = useState({
        password: '',
        confirmPassword: '',
        isMatch: false
    })

    const [notificationsState, setNotificationsState] = useState<UserNotifications>({
        dreamHome: false,
        lifestyle: false,
        fixedOdds: false,
        myCompetitions: false,
        newPrizes: false,
        all: false
    })

    useEffect(() => {
        if (notifications) {
            setNotificationsState(notifications)
        }
    }, [])

    const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isMatch = checkPassword(e.currentTarget.value, state.confirmPassword)
        setState({ ...state, password: e.currentTarget.value, isMatch: isMatch })
    }

    const handleConfirmPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isMatch = checkPassword(state.password, e.currentTarget.value)
        setState({ ...state, confirmPassword: e.currentTarget.value, isMatch: isMatch })
    }

    const saveChanges = async () => {
        const result = await dataProvider.update('users/cms/forgot', {
            id: id,
            data: { password: state.password },
            previousData: {} as User
        })
        if (result.data) {
            notify("Password changed", "info")
        }
    }

    return (
        <>
            <Typography variant="h6" className="base-color" >
                Change User password
            </Typography>
            <Box width="30%">
                <Box display="flex" alignItems="flex-end" paddingBottom="1em" justifyContent="space-between" >
                    <Typography className="base-color">
                        New password
                    </Typography>
                    <Box width="50%" display="flex" alignItems="center" marginLeft="5em">
                        <div className="coordinates">
                            <TextField
                                id="user-general-input"
                                disabled={isShow}
                                label="Address*"
                                className="address-field"
                                onChange={handlePassword}
                            />
                            <Box position="absolute">
                                {state.password.length > 1 && state.password.length < 6 && <div className="date-error">Should be at least 6 characters</div>}
                                {state.password.length > 20 && <div className="date-error">Should be less then 20 characters</div>}
                            </Box>
                        </div>
                    </Box>
                </Box>

                <Box display="flex" alignItems="flex-end" paddingBottom="1em" justifyContent="space-between">
                    <Typography className="base-color">
                        Confirm new password
                    </Typography>
                    <Box width="50%" display="flex" alignItems="center" marginLeft="5em">
                        <div className="coordinates">
                            <TextField
                                id="user-general-input"
                                disabled={isShow}
                                label="Address*"
                                className="address-field"
                                onChange={handleConfirmPassword}
                            />
                            <Box position="absolute">
                                {state.confirmPassword.length > 1 && !state.isMatch && <div className="date-error">Should be match with password</div>}
                            </Box>
                        </div>
                    </Box>
                </Box>
            </Box>
            <Box padding="24px 0 24px 24px">
                <Button onClick={saveChanges} disabled={!state.isMatch || state.password.length < 6} className={state.isMatch && state.password.length >= 6 ? "change-password-button" : 'disable-password-button'}>Save Changes</Button>
            </Box>
            <Box marginBottom="5em" width="30%">
                <Typography variant="h6" className="base-color" >
                    Notifications
            </Typography>
                <Box marginTop="2em">
                    <Box display="flex" justifyContent="space-between" paddingBottom="1em">
                        <Typography className="base-color">
                            Dream Home updates
                    </Typography>
                        <Box width="50%" display="flex" alignItems="center" >
                            <label className="switch checkbox-margin">
                                <input type="checkbox" checked={notificationsState.dreamHome} disabled />
                                <span className="slider round"></span>
                            </label>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" paddingBottom="1em">
                        <Typography className="base-color">
                            Lifestyle Prize updates
                    </Typography>
                        <Box width="50%" display="flex" alignItems="center" >
                            <label className="switch checkbox-margin">
                                <input type="checkbox" checked={notificationsState.lifestyle} disabled/>
                                <span className="slider round"></span>
                            </label>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" paddingBottom="1em">
                        <Typography className="base-color">
                            Fixed Odds updates
                    </Typography>
                        <Box width="50%" display="flex" alignItems="center" >
                            <label className="switch checkbox-margin">
                                <input type="checkbox" checked={notificationsState.fixedOdds} disabled/>
                                <span className="slider round"></span>
                            </label>
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between" paddingBottom="1em">
                        <Typography className="base-color">
                            My Saved competitions
                    </Typography>
                        <Box width="50%" display="flex" alignItems="center" >
                            <label className="switch checkbox-margin">
                                <input type="checkbox" checked={notificationsState.myCompetitions} disabled />
                                <span className="slider round"></span>
                            </label>
                        </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between" paddingBottom="1em">
                        <Typography className="base-color">
                            New Prize, Deals & Offers
                    </Typography>
                        <Box width="50%" display="flex" alignItems="center">
                            <label className="switch checkbox-margin">
                                <input type="checkbox" checked={notificationsState.newPrizes} disabled/>
                                <span className="slider round"></span>
                            </label>
                        </Box>
                    </Box>
                    <Box display="flex" justifyContent="space-between" paddingBottom="1em">
                        <Typography className="base-color">
                            All notifications
                    </Typography>
                        <Box width="50%" display="flex" alignItems="center">
                            <label className="switch checkbox-margin">
                                <input type="checkbox" checked={notificationsState.all} disabled/>
                                <span className="slider round"></span>
                            </label>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default SecurityTab